import React from "react";
import { CalendarPlus, Apple } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { googleCalendarUrl, downloadIcs } from "../../lib/calendar";

export const AddToCalendar = ({ appt, variant = "button", className = "" }) => {
  if (!appt?.date || !appt?.time) return null;

  const triggerClasses =
    variant === "button"
      ? `inline-flex items-center justify-center gap-2 rounded-lg bg-gold/15 hover:bg-gold/25 text-gold-dark font-medium text-sm py-2.5 px-4 transition-colors ${className}`
      : `inline-flex items-center gap-1 text-xs font-medium text-navy hover:text-gold-dark px-2 py-1.5 rounded-md hover:bg-white transition-colors ${className}`;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={triggerClasses} data-testid={`add-to-calendar-${appt.id || "new"}`}>
        <CalendarPlus className="h-4 w-4" /> Add to calendar
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuItem asChild data-testid="cal-google">
          <a href={googleCalendarUrl(appt)} target="_blank" rel="noreferrer" className="cursor-pointer">
            <CalendarPlus className="h-4 w-4 mr-2 text-gold-dark" /> Google Calendar
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => downloadIcs(appt)} className="cursor-pointer" data-testid="cal-apple">
          <Apple className="h-4 w-4 mr-2 text-navy" /> Apple Calendar
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => downloadIcs(appt)} className="cursor-pointer" data-testid="cal-outlook">
          <CalendarPlus className="h-4 w-4 mr-2 text-navy" /> Outlook / iCal (.ics)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
